import type { StockGroupDto, StockPlaceDto } from '@eombor/contracts';

/**
 * Bitta ombordagi butun qoldiq — kataklari bilan birga.
 *
 * `WarehouseStock` (`stock-warehouses.ts`) dan farqi shu: u BUYURTMACHI
 * uchun va katakni bilmaydi — buyurtmachi katakka bormaydi. Bu esa
 * skladchi uchun: uning savoli "qaysi katakdan olay?" va javob katak
 * kodisiz to'liq emas.
 */
export interface WarehousePlaces {
  warehouseId: string;
  warehouseName: string;
  /** Ombordagi jami mavjud — kataklar yig'indisi. */
  availableQty: number;
  /** Ombordagi jami band. */
  reservedQty: number;
  /** Ombordagi jami qoldiq (mavjud + band). */
  qty: number;
  /** Shu ombordagi kataklar — kod bo'yicha tartiblangan. */
  places: StockPlaceDto[];
}

/**
 * Katak aniqligidagi ro'yxatni OMBOR bo'yicha guruhlaydi.
 *
 * Guruhlash `warehouseId` bo'yicha, NOM bo'yicha emas: ikki tashkilotda
 * bir xil nomli ombor bo'lishi mumkin va nom bo'yicha yig'ilsa, ikki
 * boshqa ombor bitta blokka qo'shilib ketardi.
 *
 * Tartib ikki darajali: omborlar ko'p mavjudi bo'yicha (kerakli miqdorni
 * topish uchun ro'yxatning boshini o'qish kifoya), ombor ichidagi kataklar
 * esa KOD bo'yicha — katak kodi javon manzili va u ketma-ket o'qilganda
 * skladchi ombor bo'ylab bir yo'nalishda yuradi.
 */
export const placesByWarehouse = (group: StockGroupDto): WarehousePlaces[] => {
  const byWarehouse = new Map<string, WarehousePlaces>();

  for (const place of group.places) {
    const row = byWarehouse.get(place.warehouseId);
    if (row === undefined) {
      byWarehouse.set(place.warehouseId, {
        warehouseId: place.warehouseId,
        warehouseName: place.warehouseName,
        availableQty: place.availableQty,
        reservedQty: place.reservedQty,
        qty: place.qty,
        places: [place],
      });
      continue;
    }
    row.availableQty += place.availableQty;
    row.reservedQty += place.reservedQty;
    row.qty += place.qty;
    row.places.push(place);
  }

  const rows = [...byWarehouse.values()];
  for (const row of rows) {
    row.places.sort((a, b) => a.cellCode.localeCompare(b.cellCode));
  }
  return rows.sort((a, b) => b.availableQty - a.availableQty);
};
